/**
 * Formatting utilities
 */

/**
 * Format a device name for display
 * Converts kebab-case or snake_case to Title Case
 */
export function formatDeviceName(name: string): string {
  return name.replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Format a sensor value with its unit
 */
export function formatSensorValue(value: number, unit: string): string {
  // Handle common unit formatting
  const formattedValue = Number.isInteger(value) ? value.toString() : value.toFixed(1);

  // Some units should be attached without space
  const noSpaceUnits = ['%', '°C', '°F'];
  const separator = noSpaceUnits.includes(unit) ? '' : ' ';

  return `${formattedValue}${separator}${unit}`;
}

/**
 * Format a percentage value (0-100 or 0-255 depending on context)
 */
export function formatPercentage(value: number, max: number = 100): string {
  const percentage = Math.round((value / max) * 100);
  return `${percentage}%`;
}

/**
 * Format a relative time (e.g., "2 minutes ago")
 */
export function formatRelativeTime(date: Date | string): string {
  const now = new Date();
  const then = typeof date === 'string' ? new Date(date) : date;
  const diffMs = now.getTime() - then.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSeconds < 60) {
    return 'just now';
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  } else if (diffDays < 7) {
    return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
  } else {
    return then.toLocaleDateString();
  }
}
